<template>
  <div>
    <DashboardHeader title="Financial Accounts">
      <v-layout row wrap v-if="isManager">
        <v-snackbar v-model="snackBar" dark :color="getThemeColor">
          {{ snackText }}
          <v-btn color="pink" text @click="snackBar = false">Close</v-btn>
        </v-snackbar>
        <v-flex xs12 sm3>
          <v-card
            class="mx-4 mt-6"
            v-if="isManager"
            shaped
            elevation="12"
            max-width="344"
            outlined
            :color="getThemeColor"
            dark
          >
            <v-list-item three-line>
              <p>Financial Accounts</p>
            </v-list-item>
          </v-card>

          <v-card class="mx-4 mt-6" v-if="isManager" shaped elevation="12" max-width="344" outlined>
            <v-card-title class="ml-4">
              {{title}}
              <v-btn class="mx-4" color="success" rounded small @click="saveAccount()">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-card-title>
            <div class="mx-4">
              <v-list-item three-line>
                <v-text-field class="mr-16" label="Account Name" v-model="accountName"></v-text-field>
              </v-list-item>
              <v-list-item three-line>
                <v-text-field class="mr-16" label="Account Type" v-model="accountType"></v-text-field>
              </v-list-item>
              <v-list-item three-line>
                <v-text-field class="mr-16" label="Account Balance" v-model="accountBalance"></v-text-field>
              </v-list-item>
            </div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm8 class="mx-4 mt-6">
          <v-row>
            <v-switch
              :disabled="accounts.length < 1"
              v-model="selectAll"
              label="Select All"
              class="ml-2 mt-8"
              @change="selectAllAccounts()"
            ></v-switch>
            <v-btn
              v-if="isManager"
              @click="openBulkDeleteDialog()"
              x-small
              rounded
              color="red"
              dark
              class="mt-8 ml-2"
            >
              <v-icon left>mdi-delete</v-icon>Bulk Delete
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              class="mt-4 ml-2 mb-4"
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              style="display:inline"
            ></v-text-field>
          </v-row>

          <v-data-table :headers="headers" :items="accounts" :search="search">
            <template v-slot:item.selection="{item}">
              <v-checkbox class="shrink" :value="item.id" v-model="selectedAccounts"></v-checkbox>
            </template>

            <template v-slot:item.name="{item}">
              <v-text-field @change="updateField(item.id,'name')" v-model="item.name"></v-text-field>
            </template>
            <template v-slot:item.type="{item}">
              <v-text-field @change="updateField(item.id,'type')" v-model="item.type"></v-text-field>
            </template>

            <template v-slot:item.balance="{item}">
              <v-text-field @change="updateField(item.id,'balance')" v-model="item.balance"></v-text-field>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" width="600" persistent>
        <v-card v-if="bulkDelete">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >Delete Selected Accounts</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Selected Accounts: {{selectedAccounts.length}}</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="error" dark @click="deleteBulkNow()">Delete Now</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";

export default {
  components: {
    DashboardHeader
  },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    }
  },
  mounted() {
    this.renderAccounts();
  },
  data() {
    return {
      rules: [value => !!value || "This Field is Required!"],
      snackBar: false,
      snackText: null,
      accountName: null,
      accountType: "Cheque-Current",
      accountBalance: 0,
      bulkDelete: false,
      dialog: false,
      accounts: [],
      title: "Add Account",
      selectedAccounts: [],
      search: null,
      selectAll: false,
      headers: [
        { value: "selection" },
        {
          text: "Account Name",
          align: "start",
          value: "name"
        },
        { text: "Account Type", value: "type" },
        { text: "Balance", value: "balance" }
      ]
    };
  },
  methods: {
    selectAllAccounts() {
      if (this.selectAll) {
        this.selectedAccounts = [];
        this.accounts.forEach(account => {
          this.selectedAccounts.push(account.id);
        });
      } else {
        this.selectedAccounts = [];
      }
    },

    saveAccount() {
      if (this.accountName != null && this.accountType != null) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/save-financial-account",
            {
              accountName: this.accountName,
              accountType: this.accountType,
              accountBalance: this.accountBalance
            },
            this.getAccessToken
          )
          .then(accounts => {
            this.renderAccounts();
            this.$store.commit("setLoader", false);
          });
      } else {
        alert("All Fields Are Required !!");
        event.preventDefault();
        return false;
      }
    },
    resetVariables() {
      (this.expenseAmount = 0),
        (this.expenseDate = new Date().toISOString().substr(0, 10));
      this.title = "Add Expense";
      this.expenseID = 0;
    },
    updateField(id, column) {
      const value = event.target.value;
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table: "accounts", id, column, value },
          this.getAccessToken
        )
        .then(response => {
          const nothing = response;
        });
    },
    editAccount(item) {
      (this.selectedServiceProvider = item.service_provider_id),
        (this.selectedExpenseCategory = item.expenses_category_id),
        (this.expenseAmount = item.amount),
        (this.expenseDate = item.entry_date);
      this.title = "Edit Expense " + item.id;
      this.expenseID = item.id;
    },
    openBulkDeleteDialog() {
      if (this.selectedAccounts.length < 1) {
        alert("You Must Select At least One(1) Account!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.bulkDelete = true;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.bulkDelete = false;
    },
    deleteBulkNow() {
      this.$store.commit("setLoader", true);

      axios
        .postDataWithToken(
          "/auth/bulk-delete-accounts",
          {
            table: "accounts",
            aids: this.selectedAccounts
          },
          this.getAccessToken
        )
        .then(accounts => {
          this.accounts = accounts;
          this.closeDialog();
          this.renderAccounts();
          this.$store.commit("setLoader", false);
        });
    },
    renderAccounts() {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-all-financial-accounts", this.getAccessToken)
        .then(accounts => {
          this.accounts = accounts;

          this.$store.commit("setLoader", false);
        });
    }
  }
};
</script>

<style>
</style>